import React, {
  useCallback,
  useEffect,
  useState,
  useMemo, useRef
} from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react';
import notify from 'devextreme/ui/notify';
import { formatMessage } from 'devextreme/localization';
import { isOne, isOneFlag, isOneQCShipment, isTestPlatform } from '../../utils/functions';
import DataGridMVP from '../DataGridMVP';
import HeaderButtonMVP from '../HeaderButtonMVP';

import columnDataGrid from './columnDataGrid';
import columnDataTranspOrder from './columnDataTranspOrder';
import columnDataProjectNum from './columnDataProjectNum';
import columnDataMX1 from './_consignment/columnDataMX1';
import columnDataMX3 from './_consignment/columnDataMX3';
import columnDataSemiAttrb from './columnDataSemiAttrb';
import columnDataTN from './columnDataTN';
import columnDataClientArrival from './columnDataClientArrival';

const Shipment = ({
  fieldsOrderReducer: { localStorageData, updateGrid },
  settingsReducer: { settings },
  shipmentReducer: {
    listShipment,
    loadingData,
    okRequest,
    okConsignment,
    okList,
    okUpdate
  },
  tabsReducer: { tabSelect },
  userReducer: {
    permissions,
    id
  },
  fieldsOrderInitialState,
  getFieldsOrder,
  getShipment,
  isOffBalanceSheet,
  isUseM4,
  isUseMhOnExpeditor,
  isUseProhibitionShipping,
  modalErrorOpen,
  modalShipmentAddReportOverdueOpen,
  modalShipmentCancelReasonOpen,
  modalShipmentPlanCancelOpen,
  modalShipmentPlanOpen,
  modalShipmentReturnOpen,
  modalShipmentSubmergeOpen,
  modalShipmentSZRebindingOpen,
  modalShipmentClientArrivalDateOpen,
  modalSKZipOpen,
  plantId,
  showTranspOrder
}) => {
  /** фильтры из localStorage */
  const localTemp = JSON.parse(localStorage.getItem(`dataGridShipment${plantId}`));

  /** Данные по таблице */
  const [thisDataGridInstance, setThisDataGridInstance] = useState({});
  /**
   * Переменная для определения текущего рендера списка,
   * где 0 = первый рендер или очистка фильтра
   */
  const isListMounted = useRef(0);

  /** Фильтры по таблице */
  const [filterDataGrid, setFilterDataGrid] = useState({
    dateFrom: '',
    dateTo: '',
    filter: localTemp ? localTemp.searchText : '',
    statusId: null
  });

  /** Сохранение фильтров для сравнения изменений перед запросом */
  const prevFilterDataGrid = useRef(filterDataGrid);

  /** Видимость поля при селекте строчек */
  const [headButtVisibol, setHeadButtVisibol] = useState({ display: 'none' });

  /** Выбор строк */
  const [dataSource, setDataSource] = useState({
    count: [0, 0, 0],
    listSubmerge: '',
    listNotSubmerge: '',
    listHold: '',
    listSubmergeItems: [],
    listHoldItems: [],
    selectSubmergeItems: [],
    selectNotSubmergeItems: [],
    selectNotSubmergeItemsQcIds: [],
    selectProhibitionItems: [],
    selectRejectText: '',
    itemAcceptContainer: '',
    itemAcceptLoadDate: '',
    itemAcceptPlomba: '',
    itemAcceptTtn: '',
    itemAcceptTtnDate: '',
    itemAcceptVehicle: '',
    itemAcceptActualShipmentDate: '',
    skData: {
      count: 0,
      data: {}
    },
    itemAcceptNextPlant: '',
    itemAcceptMH3: '',
    itemAcceptContainerInspectedFlag: false,
    qcShopId: null,
    itemAcceptShippingOnBoards: ''
  });

  // todo переделать на один компонент
  /** Выборка элементов */
  const [selectItem, setSelectItem] = useState([]);
  // Выбранные элементы списка
  const [checked, setChecked] = useState([]);

  /** Сохранение выбранных элементов для передачи в запрос,
   * чтобы не реагировать на каждое изменение checked */
  const prevCheckedRef = useRef(checked);

  /** Стейт обновлены ли поля для изменения ширины */
  const [isFieldsUpdate, setIsFieldUpdate] = useState(false);

  // изменение переменной после получения списка
  useEffect(() => {
    if (okList) {
      isListMounted.current += 1;
    }
  }, [okList]);

  // Сохранение выбранных элементов текущей вкладки в хранилище
  useEffect(() => {
    if (tabSelect === 0) {
      window.localStorage.setItem('checkedItems', JSON.stringify(checked.map(({ pieceNumId, qcId, actualPieceId, cgId }) => ({ pieceNumId, qcId, actualPieceId, cgId }))));
    } else {
      window.localStorage.removeItem('checkedItems');
    }
  }, [checked, tabSelect]);

  /** Видимость кнопок - Отгрузка, Отмена отгрузки */
  const [visibleBtn, setVisibleBtn] = useState({
    btnShipping: false,
    btnShippingCancel: false,
    btnRebinding: false
  });

  /** Признак карантина */
  const [isHoldOn, setIsHoldOn] = useState(false);

  /** Если выбраны УЕ с разными onHoldFlag */
  const [isDifferentHoldFlag, setIsDifferentHoldFlag] = useState(false);

  /** Если выбраны УЕ с разными цехами отгрузки сертификатов */
  const [isDifferentQCShipment, setIsDifferentQCShipment] = useState(false);

  useEffect(() => {
    if (tabSelect === 0) {
      isListMounted.current = 0;
    }
  }, [tabSelect]);

  useEffect(() => {
    if (permissions.length) {
      setVisibleBtn({
        btnShipping: permissions.indexOf('btnShipping') !== -1,
        btnShippingCancel: permissions.indexOf('btnShippingCancel') !== -1,
        btnRebinding: settings.useSZRebinding
          && permissions.indexOf('prmChangeSO') !== -1
      });
    }
  }, [permissions, settings]);

  /** Всплывающая подсказка */
  useEffect(() => {
    if (okRequest) {
      notify(
        {
          message: formatMessage('dataSuccess'),
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'success',
        2000
      );
      thisDataGridInstance.instance.clearSelection();
      // setModalData({
      //   visibleAccept: false,
      //   visibleReject: false
      // });
    }
  }, [okRequest, thisDataGridInstance]);

  useEffect(() => {
    prevCheckedRef.current = checked;
  }, [checked]);

  useEffect(() => {
    if (tabSelect !== 0 || id === null) return;

    const prevChecked = prevCheckedRef.current;

    if (okUpdate) {
      getShipment({
        ...filterDataGrid,
        plantId,
        items: prevChecked.map(({ pieceNumId }) => pieceNumId)
      });
      thisDataGridInstance.instance.clearSelection();

      return;
    }

    // после загрузки таблицы ссылка на объект фильтров меняется,
    // и получается, что предыдущие и текущие фильтры не равны
    const isFilterActive = Object.values(filterDataGrid).filter(Boolean).length;
    const filtersChanged = prevFilterDataGrid.current !== filterDataGrid;

    // если фильтры изменились
    if (filtersChanged) {
      getShipment({
        ...filterDataGrid,
        plantId,
        items: prevChecked.map(({ pieceNumId }) => pieceNumId)
      });

      return;
    }

    // если это первый рендер и фильтры пустые
    if ((isListMounted.current === 0 && !isFilterActive) || updateGrid) {
      if (!localStorageData) {
        getFieldsOrder({
          gridName: 'Shipment',
          plantType: '',
          plantId,
          storingName: ''
        });
      }
      getShipment({
        ...filterDataGrid,
        plantId,
        items: []
      });
      fieldsOrderInitialState();
    }

    isListMounted.current += 1;
    prevFilterDataGrid.current = filterDataGrid;
  }, [
    tabSelect,
    id,
    okUpdate,
    filterDataGrid,
    plantId,
    localStorageData,
    getFieldsOrder,
    getShipment,
    thisDataGridInstance.instance,
    updateGrid,
    fieldsOrderInitialState
  ]);

  /** Анимация загрузки данных */
  useEffect(() => {
    if (thisDataGridInstance.instance) {
      if (loadingData) {
        thisDataGridInstance.instance.beginCustomLoading('Loading...');
      } else {
        thisDataGridInstance.instance.endCustomLoading();
      }
    }
  }, [loadingData, thisDataGridInstance]);

  /** Функция открытия модальки на погрузку */
  const onClickButtonSubmerge = useCallback(() => {
    if (isDifferentHoldFlag) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textDifferentHoldFlag}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else if (isDifferentQCShipment) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textDifferentQCShipment}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else if (!isOne(
      selectItem.filter((item) => dataSource.listSubmergeItems.indexOf(item.pieceNumId) >= 0),
      'shipmentModeRequirement', 0
    ) && settings.checkDifferentShipmentMode) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textDifferentShipmentMode}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else {
      if (dataSource.selectSubmergeItems.length === 1) {
        setDataSource({
          ...dataSource,
          itemAcceptContainer: dataSource.selectSubmergeItems[0].container,
          itemAcceptPlomba: dataSource.selectSubmergeItems[0].plomba,
          itemAcceptTtn: dataSource.selectSubmergeItems[0].ttn,
          itemAcceptTtnDate: dataSource.selectSubmergeItems[0].ttnDate,
          itemAcceptVehicle: dataSource.selectSubmergeItems[0].vehicleIdOut,
          itemAcceptLoadDate:
          dataSource.selectSubmergeItems[0].dateLoadInContainer,
          itemAcceptActualShipmentDate:
          dataSource.selectSubmergeItems[0].actualShippingDate,
          itemAcceptNextPlant: dataSource.selectSubmergeItems[0].nextPlant,
          itemAcceptMH3: dataSource.selectSubmergeItems[0].mh3,
          itemAcceptContainerInspectedFlag: dataSource.selectSubmergeItems[0]
            .containerInspectedFlag,
          qcShopId: dataSource.selectSubmergeItems[0].qcShopId,
          itemAcceptShippingOnBoards: dataSource.selectSubmergeItems[0].shippingOnBoards,
          itemAcceptShipmentModeRequirement:
          dataSource.selectSubmergeItems[0].shipmentModeRequirement
        });
        if (
          isOne(
            selectItem.filter((item) => dataSource.listSubmergeItems.indexOf(item.pieceNumId) >= 0),
            'plantId',
            Number(plantId)
          ) || plantId > 10000
        ) {
          modalShipmentSubmergeOpen({
            selectSubmergeItems: dataSource.selectSubmergeItems,
            plantId,
            listSubmergeItems: dataSource.listSubmergeItems,
            itemAcceptContainer: dataSource.selectSubmergeItems[0].container,
            itemAcceptPlomba: dataSource.selectSubmergeItems[0].plomba,
            itemAcceptTtn: dataSource.selectSubmergeItems[0].ttn,
            itemAcceptTtnDate: dataSource.selectSubmergeItems[0].ttnDate,
            itemAcceptVehicle: dataSource.selectSubmergeItems[0].vehicleIdOut,
            itemAcceptLoadDate:
            dataSource.selectSubmergeItems[0].dateLoadInContainer,
            itemAcceptActualShipmentDate:
            dataSource.selectSubmergeItems[0].actualShippingDate,
            itemAcceptNextPlant: dataSource.selectSubmergeItems[0].nextPlant,
            itemAcceptMH3: dataSource.selectSubmergeItems[0].mh3,
            itemAcceptContainerInspectedFlag: dataSource.selectSubmergeItems[0]
              .containerInspectedFlag,
            qcShopId: dataSource.selectSubmergeItems[0].qcShopId,
            itemAcceptShippingOnBoards: dataSource.selectSubmergeItems[0].shippingOnBoards,
            itemAcceptShipmentModeRequirement:
            dataSource.selectSubmergeItems[0].shipmentModeRequirement
          });
        } else {
          modalErrorOpen({
            message: formatMessage('textError').differentWarehousesSelected,
            techInfo: '',
            types: 'info',
            title: formatMessage('textError').warning
          });
        }
      }
      if (dataSource.selectSubmergeItems.length > 1) {
        const tempData = dataSource.selectSubmergeItems[0];
        dataSource.selectSubmergeItems.forEach((item) => {
          if (tempData.container !== item.container) {
            tempData.container = '';
          }
          if (tempData.plomba !== item.plomba) {
            tempData.plomba = '';
          }
          if (tempData.ttn !== item.ttn) {
            tempData.ttn = '';
          }
          if (tempData.ttnDate !== item.ttnDate) {
            tempData.ttnDate = '';
          }
          if (tempData.vehicleIdOut !== item.vehicleIdOut) {
            tempData.vehicleIdOut = '';
          }
          if (tempData.dateLoadInContainer !== item.dateLoadInContainer) {
            tempData.dateLoadInContainer = '';
          }
          if (tempData.actualShippingDate !== item.actualShippingDate) {
            tempData.actualShippingDate = '';
          }
          if (tempData.nextPlant !== item.nextPlant) {
            tempData.nextPlant = '';
          }
          if (tempData.mh3 !== item.mh3) {
            tempData.mh3 = '';
          }
          if (tempData.containerInspectedFlag !== item.containerInspectedFlag) {
            tempData.containerInspectedFlag = null;
          }
          if (tempData.qcShopId !== item.qcShopId) {
            tempData.qcShopId = '';
          }
          if (tempData.shippingOnBoards !== item.shippingOnBoards) {
            tempData.shippingOnBoards = '';
          }
        });
        setDataSource({
          ...dataSource,
          itemAcceptContainer: tempData.container,
          itemAcceptPlomba: tempData.plomba,
          itemAcceptTtn: tempData.ttn,
          itemAcceptTtnDate: tempData.ttnDate,
          itemAcceptVehicle: tempData.vehicleIdOut,
          itemAcceptLoadDate: tempData.dateLoadInContainer,
          itemAcceptActualShipmentDate: tempData.actualShippingDate,
          itemAcceptNextPlant: tempData.nextPlant,
          itemAcceptMH3: tempData.mh3,
          itemAcceptContainerInspectedFlag: tempData.containerInspectedFlag,
          qcShopId: tempData.qcShopId,
          itemAcceptShippingOnBoards: tempData.shippingOnBoards,
          itemAcceptShipmentModeRequirement: tempData.shipmentModeRequirement
        });
        if (
          isOne(
            selectItem.filter((item) => dataSource.listSubmergeItems.indexOf(item.pieceNumId) >= 0),
            'plantId',
            Number(plantId)
          ) || plantId > 10000
        ) {
          modalShipmentSubmergeOpen({
            selectSubmergeItems: dataSource.selectSubmergeItems,
            plantId,
            listSubmergeItems: dataSource.listSubmergeItems,
            itemAcceptContainer: tempData.container,
            itemAcceptPlomba: tempData.plomba,
            itemAcceptTtn: tempData.ttn,
            itemAcceptTtnDate: tempData.ttnDate,
            itemAcceptVehicle: tempData.vehicleIdOut,
            itemAcceptLoadDate: tempData.dateLoadInContainer,
            itemAcceptActualShipmentDate: tempData.actualShippingDate,
            itemAcceptNextPlant: tempData.nextPlant,
            itemAcceptMH3: tempData.mh3,
            itemAcceptContainerInspectedFlag: tempData.containerInspectedFlag,
            qcShopId: tempData.qcShopId,
            itemAcceptShippingOnBoards: tempData.shippingOnBoards,
            itemAcceptShipmentModeRequirement: tempData.shipmentModeRequirement
          });
        } else {
          modalErrorOpen({
            message: formatMessage('textError').differentWarehousesSelected,
            techInfo: '',
            types: 'info',
            title: formatMessage('textError').warning
          });
        }
      }
    }
  }, [
    dataSource,
    isDifferentHoldFlag,
    isDifferentQCShipment,
    modalErrorOpen,
    modalShipmentSubmergeOpen,
    plantId,
    selectItem,
    settings
  ]);

  /** Функция открытия модальки на отмену отгрузки */
  const onClickButtonNotSubmerge = useCallback(() => {
    if (isDifferentHoldFlag) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textDifferentHoldFlag}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else if (isDifferentQCShipment) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textDifferentQCShipment}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else if (
      isOne(
        selectItem.filter(
          (item) => dataSource.selectNotSubmergeItems.indexOf(item.pieceNumId) >= 0
        ),
        'plantId',
        Number(plantId)
      ) || plantId > 10000
    ) {
      modalShipmentCancelReasonOpen({
        plantId,
        selectList: dataSource.selectNotSubmergeItems,
        listNotSubmerge: dataSource.listNotSubmerge,
        selectListData: selectItem.filter(
          (item) => dataSource.selectNotSubmergeItems.indexOf(item.pieceNumId) >= 0
        )
      });
    } else {
      modalErrorOpen({
        message: formatMessage('textError').differentWarehousesSelected,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
  }, [
    isDifferentHoldFlag,
    isDifferentQCShipment,
    selectItem,
    plantId,
    modalErrorOpen,
    dataSource.selectNotSubmergeItems,
    dataSource.listNotSubmerge,
    modalShipmentCancelReasonOpen
  ]);

  /** Функция открытия модальки на добавление УЕ в отчёт сверх нормативного хранения */
  const onClickButtonAddToReport = useCallback(() => (
    modalShipmentAddReportOverdueOpen({
      listItems: selectItem
    })
  ), [selectItem, modalShipmentAddReportOverdueOpen]);

  /** Событие на выделение строк */
  const dataGridOnSelection = useCallback(
    (selectedRowsData, component, dataSourceDop) => {
      setSelectItem(selectedRowsData);
      if (selectedRowsData.length) {
        const temp = [0, 0, 0];
        let listSubmerge = '';
        let listNotSubmerge = '';
        let listHold = '';
        const selectSubmergeItems = [];
        const listSubmergeItems = [];
        const listHoldItems = [];
        const selectNotSubmergeItems = [];
        const selectNotSubmergeItemsQcIds = [];
        const selectProhibitionItems = [];
        const rowsToDeselect = [];
        let prover = false;
        const skData = {
          count: 0,
          data: {}
        };
        if (!isOneFlag(
          selectedRowsData,
          'onHoldFlag'
        )) {
          setIsDifferentHoldFlag(true);
        }
        if (isOneQCShipment(selectedRowsData,
          'qcShopId') && settings.useShippingVehicleOnly) {
          setIsDifferentQCShipment(true);
        }
        setIsHoldOn(false);
        setChecked(selectedRowsData);
        selectedRowsData.forEach((item) => {
          if (item.onHoldFlag) {
            temp[2] += 1;
            listHold += `${item.cgId} ${item.actualPieceId}; `;
            listHoldItems.push(item.pieceNumId);
            prover = true;
            setIsHoldOn(true);
          } else if (item.psStatusName === 'Возвращен') {
            // Снятие выделение с возврата
            rowsToDeselect.push(item.pieceNumId);
            const returnMessage = item.returnVehicle
              ? `${formatMessage('textModal').textIncomingF1Left} ${item.qcId} ${formatMessage('textModal').textIncomingF1Right}`
              : `${formatMessage('textModal').textIncomingF2Left} ${item.qcId} ${formatMessage('textModal').textIncomingF2Right}`;

            modalErrorOpen({
              message: returnMessage,
              techInfo: '',
              types: 'info',
              title: formatMessage('textError').warning
            });
          } else if (isUseProhibitionShipping && item.prohibition === 'Запрет') {
            selectProhibitionItems.push(item.pieceNumId);
            listSubmergeItems.push(item.pieceNumId);
          } else {
            skData.count += 1;
            skData.data[item.qcId] = { qcShop: item.qcShopCode, qcDate: item.accountingDate };

            // если есть мастер рулон
            // eslint-disable-next-line no-lonely-if
            if (item.mcNumId) {
              rowsToDeselect.push(item.pieceNumId);
              try {
                modalErrorOpen({
                  message: `${formatMessage('textModal').textMPLeft} ${item.mcNum} ${formatMessage('textModal').textMPRight}`,
                  techInfo: '',
                  types: 'info',
                  title: formatMessage('textError').warning
                });
              } catch (e) {
                console.debug('Ошибка при выделение рулона, который в мастер рулоне', e);
              }
            } else if (item.psStatusName === 'В наличии') {
              temp[0] += 1;
              listSubmerge += `${item.cgId} ${item.actualPieceId}; `;
              selectSubmergeItems.push(item);
              listSubmergeItems.push(item.pieceNumId);
              prover = true;
            } else if (item.psStatusName === 'Отгружен') {
              temp[1] += 1;
              listNotSubmerge += `${item.cgId} ${item.actualPieceId}; `;
              selectNotSubmergeItems.push(item.pieceNumId);
              selectNotSubmergeItemsQcIds.push(item.qcId);
              prover = true;
            } else if (item.psStatusName === 'В пути') {
              // rowsToDeselect.push(item.pieceNumId);
              listSubmergeItems.push(item.pieceNumId);
            } else if (item.psStatusName === 'Возвращен') {
              // Снятие выделение с возврата
              rowsToDeselect.push(item.pieceNumId);
              const returnMessage = item.returnVehicle
                ? `${formatMessage('textModal').textIncomingF1Left} ${item.qcId} ${formatMessage('textModal').textIncomingF1Right}`
                : `${formatMessage('textModal').textIncomingF2Left} ${item.qcId} ${formatMessage('textModal').textIncomingF2Right}`;

              modalErrorOpen({
                message: returnMessage,
                techInfo: '',
                types: 'info',
                title: formatMessage('textError').warning
              });
            }
          }
        });
        if (rowsToDeselect.length) {
          component.deselectRows(rowsToDeselect);
        }
        setDataSource({
          ...dataSourceDop,
          count: temp,
          listSubmerge,
          listNotSubmerge,
          listHold,
          listSubmergeItems,
          listHoldItems,
          selectSubmergeItems,
          selectNotSubmergeItems,
          selectNotSubmergeItemsQcIds,
          selectProhibitionItems,
          skData
        });
        if (prover) {
          setHeadButtVisibol({ display: 'flex' });
        }
      } else {
        window.localStorage.removeItem('checkedItems');
        setDataSource({
          ...dataSourceDop,
          count: [0, 0, 0],
          skData: {
            count: 0,
            data: {}
          }
        });
        setHeadButtVisibol({ display: 'none' });
        setChecked([]);
      }
    },
    [modalErrorOpen, isUseProhibitionShipping, settings]
  );

  /** Функция на обработку чекбоксов неактивными */
  const onCellPrepared = useCallback((e) => {
    // eslint-disable-next-line max-len
    // if (e.rowType === 'data' && e.column.command === 'select' && e.data.psStatusName === 'В пути') {
    //   const instatnce = CheckBox.getInstance(e.cellElement.querySelector('.dx-select-checkbox'));
    //   instatnce.option('disabled', true);
    //   e.cellElement.style.pointerEvents = 'none';
    // }
  }, []);

  /** Поисковая строка */
  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      if (!value) {
        isListMounted.current = 0;
      }
      setFilterDataGrid({ ...filterDataGrid, filter: value });
    }
  }, [filterDataGrid]);

  /** Событие на закрыть */
  const closeHeaderButtom = useCallback(() => {
    thisDataGridInstance.instance.clearSelection();
    setHeadButtVisibol({ display: 'none' });
    setIsDifferentHoldFlag(false);
    setIsDifferentQCShipment(false);
    setIsHoldOn(false);
    setChecked([]);
  }, [thisDataGridInstance.instance]);

  const onClickButtonReturn = useCallback(() => {
    if (isDifferentHoldFlag) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textDifferentHoldFlag}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else if (isDifferentQCShipment) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textDifferentQCShipment}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else if (
      isOne(
        selectItem.filter((item) => dataSource.listSubmergeItems.indexOf(item.pieceNumId) >= 0
          || dataSource.listHoldItems.indexOf(item.pieceNumId) >= 0),
        'plantId',
        Number(plantId)
      ) || plantId > 10000
    ) {
      modalShipmentReturnOpen({
        plantId,
        selectList: dataSource.listSubmergeItems.concat(dataSource.listHoldItems),
        isHoldOn
      });
    } else {
      modalErrorOpen({
        message: formatMessage('textError').differentWarehousesSelected,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
  }, [
    isDifferentHoldFlag,
    isDifferentQCShipment,
    selectItem,
    plantId,
    modalErrorOpen,
    dataSource.listSubmergeItems,
    dataSource.listHoldItems,
    modalShipmentReturnOpen,
    isHoldOn]);

  // Групповое скачивание СК
  const onClickButtonSK = useCallback(() => {
    modalSKZipOpen({
      data: dataSource.skData.data,
      plantId
    });
  }, [
    dataSource.skData.data,
    modalSKZipOpen,
    plantId
  ]);

  // Обновление данных
  const onClickUpdate = useCallback(() => {
    const isFilterActive = Object.values(filterDataGrid).filter(Boolean).length;
    getShipment({
      ...filterDataGrid,
      plantId,
      items: isFilterActive ? checked.map(({ pieceNumId }) => pieceNumId) : []
    });
  }, [filterDataGrid, getShipment, plantId, checked]);

  // Обновление данных после выкупа
  useEffect(() => {
    if (okConsignment) {
      onClickUpdate();
    }
  }, [onClickUpdate, okConsignment]);

  /** Изменение ширины полей TODO придумать что-нибудь лаконичнее */
  useEffect(() => {
    if (listShipment.length && localTemp && !isFieldsUpdate) {
      let fieldModify = false;
      let dataFieldsName = ['qcId', 'documentId', 'mh3'];
      dataFieldsName.forEach((fieldName) => {
        let controlField = {
          name: fieldName,
          maxLength: 0,
          index: 0
        };
        if (!localTemp.columns.filter((item) => item.dataField === fieldName)[0]?.width) {
          localTemp.columns.forEach((item, index) => item.dataField === fieldName ? controlField.index = index : null);
          listShipment.forEach((item) => item[fieldName]?.length * 12 > controlField.maxLength ? controlField.maxLength = item[fieldName].length * 12 : null);
          if (controlField.maxLength !== 0) {
            localTemp.columns[controlField.index].width = controlField.maxLength;
            fieldModify = true;
          }
        }
      });
      if (fieldModify) {
        localStorage.setItem(`dataGridShipment${plantId}`, JSON.stringify(localTemp));
        setIsFieldUpdate(true);
        onClickUpdate();
      }
    }
  }, [localTemp, listShipment, isFieldsUpdate, plantId, onClickUpdate]);

  /** Нажатие на планирование */
  const onClickPlan = useCallback(() => {
    if (isDifferentHoldFlag) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textDifferentHoldFlag}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else if (isDifferentQCShipment) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textDifferentQCShipment}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else {
      modalShipmentPlanOpen({
        selectList: selectItem
          .filter((item) => item.psStatusNumId === 0 || item.psStatusNumId === 2)
          .map((iitem) => iitem.pieceNumId)
      });
    }
  }, [
    isDifferentHoldFlag,
    isDifferentQCShipment,
    modalErrorOpen,
    modalShipmentPlanOpen,
    selectItem
  ]);

  /** Нажатие на отмену планирования */
  const onClickPlanCancel = useCallback(() => {
    if (isDifferentHoldFlag) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textDifferentHoldFlag}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else if (isDifferentQCShipment) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textDifferentQCShipment}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else {
      modalShipmentPlanCancelOpen({
        selectList: selectItem
          .filter(
            (item) => item.hasShippingPlan === true
            && (item.psStatusNumId === 0 || item.psStatusNumId === 2)
          )
      });
    }
  }, [
    isDifferentHoldFlag,
    isDifferentQCShipment,
    modalErrorOpen,
    modalShipmentPlanCancelOpen,
    selectItem
  ]);

  /** Фильтрация в переменные по статусу "В пути" - 0 + "В наличии" - 2 / psStatusNumId */
  const countPlan = useMemo(() => {
    const temp = selectItem.filter(
      (item) => (item.psStatusNumId === 0
          || item.psStatusNumId === 2)
        && !item.onHoldFlag
    ).length;
    if (temp) {
      setHeadButtVisibol({ display: 'flex' });
    } else {
      setHeadButtVisibol({ display: 'none' });
    }
    return temp;
  }, [selectItem]);

  /** Фильтрация в переменные
   *  по статусу "В пути" - 0 + "В наличии" - 2 / psStatusNumId и hasShippingPlan */
  const countCanselPlan = useMemo(() => {
    const temp = selectItem.filter(
      (item) => item.hasShippingPlan === true
        && (item.psStatusNumId === 0 || item.psStatusNumId === 2)
        && !item.onHoldFlag
    ).length;
    return temp;
  }, [selectItem]);

  /** открытие модального окна "Перепривязка СЗ" */
  const onClickSZRebinding = useCallback(() => {
    modalShipmentSZRebindingOpen({
      plantId,
      selectList: dataSource.selectSubmergeItems,
      filter: filterDataGrid
    });
  }, [dataSource.selectSubmergeItems, modalShipmentSZRebindingOpen, plantId, filterDataGrid]);

  const onClickClientArrivalDate = useCallback(() => {
    modalShipmentClientArrivalDateOpen({
      pieceNumIds: dataSource.selectNotSubmergeItems,
      qcIds: dataSource.selectNotSubmergeItemsQcIds,
      plantId,
      filterDataGrid
    })
  }, [
    dataSource.selectNotSubmergeItems,
    dataSource.selectNotSubmergeItemsQcIds,
    modalShipmentClientArrivalDateOpen,
    plantId,
    filterDataGrid
  ]);

  const renderColumnsDataGrid = useMemo(() => (
    columnDataGrid.map(
      (item) => {
        if (item.dataField === 'widthFact' && !settings.useMC) {
          return null;
        }

        return (
          <Column dataField={item.dataField}
                  caption={formatMessage('textTable')[item.dataField]}
                  visible={!item.notVisible}
                  allowSearch={false}
                  allowFiltering
                  cellRender={item.cellRender}
                  key={item.dataField}
                  dataType={item.dataType}
                  cssClass={item.cssClass}
                  width={item.width ? item.width : undefined}
          />
        );
      }
    )
  ), [settings.useMC]);

  const renderColumnTranspOrder = useMemo(() => (
    columnDataTranspOrder.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnProjectNum = useMemo(() => (
    columnDataProjectNum.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnMX1M4 = useMemo(() => (
    columnDataMX1.filter((item) => item.dataField !== 'mh1DocStatusDescr'
      && item.dataField !== 'departureDate')
      .map(
        (item) => (
          <Column dataField={item.dataField}
                  caption={isUseM4 ? formatMessage('textTable').MX1M4[item.dataField] : formatMessage('textTable').consignment[item.dataField]}
                  visible={!item.notVisible}
                  allowSearch={false}
                  allowFiltering
                  cellRender={item.cellRender}
                  key={item.dataField}
                  dataType={item.dataType}
                  cssClass={item.cssClass}
          />
        )
      )
  ), [isUseM4]);

  const renderColumnMX3 = useMemo(() => (
    columnDataMX3.filter((item) => item.dataField !== 'mh3Status'
      && item.dataField !== 'mh3DocStatusDescr')
      .map(
        (item) => (
          <Column dataField={item.dataField}
                  caption={formatMessage('textTable').consignment[item.dataField]}
                  visible={!item.notVisible}
                  allowSearch={false}
                  allowFiltering
                  cellRender={item.cellRender}
                  key={item.dataField}
                  dataType={item.dataType}
                  cssClass={item.cssClass}
          />
        )
      )
  ), []);

  const renderColumnTN = useMemo(() => (
    columnDataTN.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.dataField === 'ttn' ? settings.useTtnCreate ? item.cellRender : '' : item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), [settings.useTtnCreate]);

  const renderColumnSemiAttrb = useMemo(() => (
    columnDataSemiAttrb.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnClientArrival = useMemo(() => (
    columnDataClientArrival.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderDataGrid = useMemo(() => (
    <DataGridMVP dataSource={listShipment}
                 setDataGridInstance={setThisDataGridInstance}
                 onSelectionChanged={({
                   selectedRowsData,
                   component
                 }) => dataGridOnSelection(selectedRowsData, component, dataSource)}
                 filterDataGrid={filterDataGrid}
                 setFilterDataGrid={setFilterDataGrid}
                 className="shipment"
                 setStateStoringName={`dataGridShipment${plantId}`}
                 onCellPrepared={onCellPrepared}
                 dataGridOnOptionChanged={dataGridOnOptionChanged}
                 tText={formatMessage('textShipmentPeriod')}
                 loadingData={loadingData}
                 visibleButtonUpdate
                 visibleButtonSelectFields={isTestPlatform()}
                 visibleColumnChooser={isTestPlatform()}
                 onClickUpdate={onClickUpdate}
                 shrinkToolbar={headButtVisibol.display !== 'none'}
    >
      { renderColumnsDataGrid }
      { showTranspOrder ? renderColumnTranspOrder : null }
      { settings.stockType ? renderColumnProjectNum : null }
      { isUseMhOnExpeditor ? renderColumnMX1M4 : null }
      { isUseMhOnExpeditor ? renderColumnMX3 : null }
      { renderColumnTN }
      { settings.showSemiAttrb ? renderColumnSemiAttrb : null }
      { settings.useClientArrivalDate ? renderColumnClientArrival : null }
      { settings.useTtnCreate
        && (
        <Column dataField={'ttnDocStatusDescr'}
                   caption={formatMessage('textTable').ttnDocStatusDescr}
                   allowSearch={false}
                   allowFiltering
                   dataType={'string'}
        />
        )}
      { isOffBalanceSheet
        && (
          <Column dataField={'productPlanDistr'}
                  caption={formatMessage('textTable').productPlanDistr}
                  allowSearch={false}
                  allowFiltering
                  dataType={'string'}
          />
        )}
    </DataGridMVP>
  ), [
    dataGridOnOptionChanged,
    dataGridOnSelection,
    dataSource,
    filterDataGrid,
    headButtVisibol.display,
    isOffBalanceSheet,
    isUseMhOnExpeditor,
    listShipment,
    loadingData,
    onCellPrepared,
    onClickUpdate,
    plantId,
    renderColumnMX1M4,
    renderColumnMX3,
    renderColumnProjectNum,
    renderColumnsDataGrid,
    renderColumnSemiAttrb,
    renderColumnTN,
    renderColumnTranspOrder,
    renderColumnClientArrival,
    settings,
    showTranspOrder
  ]);

  return (
    <>
      <HeaderButtonMVP headButtVisibol={headButtVisibol}>
        <Button icon="close" stylingMode="text" onClick={closeHeaderButtom} />
        <span className="span-first">
          {`${formatMessage('textDataGrid').selectQU}:`}
        </span>
        {dataSource.count[0] ? (
          <>
            <span>{`“В наличии” - ${dataSource.count[0]} `}</span>
            {visibleBtn.btnShipping && !dataSource.selectProhibitionItems.length ? (
              <Button text={isOffBalanceSheet ? formatMessage('textButton').writeOff : formatMessage('textButton').submerge}
                      type="default"
                      stylingMode="contained"
                      onClick={onClickButtonSubmerge}
              />
            ) : (
              ''
            )}
          </>
        ) : (
          <div />
        )}
        {dataSource.count[1] && !dataSource.selectProhibitionItems.length ? (
          <>
            <span>{`“Отгружен” - ${dataSource.count[1]} `}</span>
            {visibleBtn.btnShippingCancel && !dataSource.selectProhibitionItems.length ? (
              <Button text={formatMessage('textButton').cancelShipment}
                      type="default"
                      stylingMode="contained"
                      onClick={onClickButtonNotSubmerge}
              />
            ) : (
              ''
            )}
          </>
        ) : (
          <div />
        )}
        {(dataSource.count[0] || dataSource.count[1])
        && !isOffBalanceSheet && !dataSource.selectProhibitionItems.length ? (
          <Button text={formatMessage('textButton').addToReportOverStorageDates}
                  type="default"
                  stylingMode="contained"
                  onClick={onClickButtonAddToReport}
          />
          ) : (
            <div />
          )}
        {(visibleBtn.btnShipping &&
          settings.useClientArrivalDate &&
          dataSource.selectNotSubmergeItems.length ?
          <Button text={formatMessage('textArrivalDate')}
                  type="default"
                  stylingMode="contained"
                  onClick={onClickClientArrivalDate}
          /> : null
        )}
        {dataSource.count[0] || dataSource.count[2] || dataSource.selectProhibitionItems.length ? (
          <>
            {dataSource.count[2] > 0 ? (<span>{`“В карантине” - ${dataSource.count[2]} `}</span>) : ('')}
            {dataSource.selectProhibitionItems.length ? (<span>{`“Запрет на загрузку” - ${dataSource.selectProhibitionItems.length} `}</span>) : ''}
            {(visibleBtn.btnShipping && !isOffBalanceSheet) ? (
              <Button text={formatMessage('textButton').textReturn}
                      type="default"
                      stylingMode="contained"
                      onClick={onClickButtonReturn}
              />
            ) : (
              ''
            )}
          </>
        ) : (
          <div />
        )}
        {dataSource.skData.count && !dataSource.selectProhibitionItems.length ? (
          <>
            <Button text={formatMessage('textButton').downloadQc}
                    type="default"
                    stylingMode="contained"
                    onClick={onClickButtonSK}
            />
          </>
        ) : (
          <div />
        )}
        {countPlan && !isOffBalanceSheet && !dataSource.selectProhibitionItems.length ? (
          <Button text={`${formatMessage('textButton').loadingPlanning} - ${countPlan}`}
                  type="success"
                  stylingMode="contained"
                  onClick={onClickPlan}
          />
        ) : (
          <div />
        )}
        {countCanselPlan && !dataSource.selectProhibitionItems.length ? (
          <Button text={`${formatMessage('textButton').cancelPlanning} - ${countCanselPlan}`}
                  type="success"
                  stylingMode="contained"
                  onClick={onClickPlanCancel}
          />
        ) : (
          <div />
        )}
        {(visibleBtn.btnRebinding && !dataSource.selectProhibitionItems.length && (
          <Button text={formatMessage('textButton').rebinding}
                  type="default"
                  stylingMode="contained"
                  onClick={onClickSZRebinding}
          />
        ))}
      </HeaderButtonMVP>
      { renderDataGrid }
      <div />
    </>
  );
};

export default React.memo(Shipment);
